import { feature, useFeature } from '@/app/context';
import type { SnapshotFrom } from 'xstate';
import type { busTimesMachine } from './bus-times.machine';
export const useBusTimesRef = () => feature('bus-times');
export const useBusTimes = <R>(selector: (snapshot: SnapshotFrom<typeof busTimesMachine>) => R) =>
  useFeature('bus-times', selector);
export const useBusTimesActions = () => {
  const ref = useBusTimesRef();
  return {
    chooseRoute: (routeId: string) => ref.send({ type: 'bus-times.choose-route', routeId }),
    chooseDirection: (directionId: string) => ref.send({ type: 'bus-times.choose-direction', directionId }),
    chooseStop: (stopId: string) => ref.send({ type: 'bus-times.choose-stop', stopId }),
    viewSchedule: () => ref.send({ type: 'bus-times.view-schedule' }),
    refreshSchedule: () => ref.send({ type: 'bus-times.refresh-schedule' }),
    recallStop: () => ref.send({ type: 'bus-times.recall-stop' }),
  };
};
